import React from 'react'
import PropTypes from 'prop-types'
import ReCAPTCHA from "react-google-recaptcha";

const recaptchaRef = React.createRef();

class CheckoutComplete extends React.Component {
    constructor(props) {
    super(props);
        this.onClick = this.onClick.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

  handleSubmit = async (e) =>{
    e.preventDefault();

    if (recaptchaRef.current) {
        const token = await recaptchaRef.current.executeAsync();
        recaptchaRef.current.reset();

        this.props.placeOrderDetails.RecaptchaToken = token;
    }

    this.onClick(e);
  }

  onClick(e) {
    this.props.onCompleteCheckout(this.props.placeOrderDetails);
  }

    render() {
    //If there are restrictions, don't show button.
    if (this.props.placeOrderDetails.HasRestrictedItems)
        return (null);
    
    return (
        <div className={`summary-complete-checkout text-center ${this.props.additionalClassname && this.props.additionalClassname}`}>
            {this.props.placeOrderDetails.UserIsAnonymous && this.props.siteKey &&
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey={this.props.siteKey}
                    size="invisible"
                />
            }
        <a
          href=""
          className='btn btn-primary mb-3'
          disabled={this.props.isPlaceOrderPending}
          onClick={(e) => this.handleSubmit(e)}
          style={{ width: '100%' }}
        >
          {this.props.buttonText}
          <span
            className={`fa fa-spin fa-spinner ml-2 ${this.props.isPlaceOrderPending ? '' : 'd-none'}`}></span>
        </a>
        {this.props.checkoutEnvironmentMessage && 
            <div 
                className='alert alert-warning'>{this.props.checkoutEnvironmentMessage}</div>
        }
      </div>
    );
  }
}

CheckoutComplete.propTypes = {
  onCompleteCheckout: PropTypes.func.isRequired,
  buttonText: PropTypes.string.isRequired,
  placeOrderDetails: PropTypes.object.isRequired,
  additionalClassname: PropTypes.string,
  isPlaceOrderPending: PropTypes.bool,
  hasRestrictedItems: PropTypes.bool,
  siteKey: PropTypes.string, 
  checkoutEnvironmentMessage: PropTypes.string,
}



export default CheckoutComplete


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/PlaceOrder/CheckoutComplete.jsx